import { __rest } from "tslib";
import { forwardRef, useEffect, useRef } from 'react';
import { generateInputFieldBase } from '../InputField/index.shell';
export const SearchField = forwardRef((_a, ref) => {
    var { onClose } = _a, props = __rest(_a, ["onClose"]);
    const searchFieldRef = useRef();
    const handleClose = (event) => {
        if (onClose) {
            onClose(event);
        }
    };
    useEffect(() => {
        var _a;
        (_a = searchFieldRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('close', handleClose);
        return () => {
            var _a;
            (_a = searchFieldRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('close', handleClose);
        };
    }, [ref, onClose]);
    return generateInputFieldBase('chameleon-search-field', props, searchFieldRef);
});
